import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=bfc0d28e&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=bfc0d28e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc0d28e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfc0d28e')) {
      api.createRecord('bfc0d28e', component.options)
    } else {
      api.reload('bfc0d28e', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=bfc0d28e&scoped=true&", function () {
      api.rerender('bfc0d28e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4ZCzvp4yJTIBb/JS/comp/Paginate.vue"
export default component.exports